import {ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {SupportDevToolService} from './support-dev-tool.service';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {DropdownMenuComponent} from '../dropdown-menu/dropdown-menu.component';

@Component({
  selector: 'ucs-support-dev-tool',
  templateUrl: './support-dev-tool.component.html',
  styleUrls: ['./support-dev-tool.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgbDropdownModule,
    DropdownMenuComponent
  ]
})
export class SupportDevToolComponent implements OnInit, OnDestroy {
  showSupportDevTool = false;

  private readonly unsubscribe: Subject<void> = new Subject<void>();
  private readonly supportDevToolService = inject(SupportDevToolService);
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);

  ngOnInit(): void {
    this.router.events
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(event => { // subscribe to change of route parameters
        if (event instanceof NavigationEnd) {
          let route = this.activatedRoute;

          while (route.firstChild) {
            route = route.firstChild;
          }
          this.showSupportDevTool = route.snapshot.data['showSupportDevTool'];
        }
      });
  }

  refreshIndex(): void {
    const urlSegments = this.router.url.split('/');
    const id = Number(urlSegments.at(-1));

    if (urlSegments.includes('offer')) {
      this.supportDevToolService
        .refreshOfferIndex(id)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: () => console.log(`Successfully refreshed index for offer ${id}`),
          error: (error: any) => console.error(`Failed to refresh index for offer ${id}`, error)
        });
    } else if (urlSegments.includes('vehicle')) {
      this.supportDevToolService
        .refreshVehicleIndex(id)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: () => console.log(`Successfully refreshed index for vehicle ${id}`),
          error: (error: any) => console.error(`Failed to refresh index for vehicle ${id}`, error)
        });
    } else {
      console.error('Unsupported URL segment!');
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
